import Swiper from 'swiper'

import BaseComponent from './_BaseComponent'




/* BASE SLIDER
----------------------------------------------------------------------------------------------------*/

export default class Slider extends BaseComponent {

    constructor($el, namespace) {
        super('Slider', $el, namespace)

        this.on()
    }


    bindProperties() {
        this.initSlider()
    }

    bindHandlers() {
        this.clickHandler = e => this.onClick(e)
    }

    bindEvents() {
        const { $nextBtn } = this.$refs

        this.addListeners(
            [$nextBtn, 'click', this.clickHandler],
        )
    }

    initSlider() {
        const loop = this.$el.attr('data-loop') !== ''

        this.swiper = new Swiper(this.$refs.slider[0], {
            // General
            loop,
            // centeredSlides: true,
            // roundLengths: true,
            slidesPerView: 'auto',
            grabCursor: true,
            speed: 400,
            watchSlidesProgress: true,
            watchOverflow: true,
            loopPreventsSlide: false,
            // centerInsufficientSlides: true,

            // Namespace
            containerModifierClass: 'slider--',
            wrapperClass: 'js-Slider-wrapper',
            slideClass: 'js-Slider-slide',
            slideActiveClass: 'is-active',
            slideVisibleClass: 'is-visible',
            slideNextClass: 'is-next',
            slidePrevClass: 'is-prev',
            slideDuplicateClass: 'slide--dup',
            slideDuplicateActiveClass: 'slide--dup--active is-active',
            slideDuplicateNextClass: 'slide--dup--next',
            slideDuplicatePrevClass: 'slide--dup--prev',


            // Navigation
            keyboard: true,



            // Breakpoints
            breakpoints: {
                960: {
                    speed: 700,
                },
            },


            // Callbacks
            on: {
                realIndexChange: s => this.onRealIndexChanged(s),
                slideChangeTransitionEnd: (s) => {
                    const transX = s.getTranslate()
                    s.setTranslate(transX)
                    // console.log(s.progress)
                },
            },
        })
    }



    /* Handlers
    --------------------------------------------------------- */

    onClick(e) {
        e.currentTarget.blur()

        this.swiper.slideNext()
    }


    onRealIndexChanged(s) {
        this.$refs.counter.text(s.realIndex + 1)
    }


}



